import * as go from 'gojs';
import { getImageGenericCrusher } from 'unitData/Generic/GenericCrusher/getImageGenericCrusher';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import type { CrusherNodeData } from '../../../../types';

const GenericCrusherTemplate = makeNode(
  getImageBinding('', (data: CrusherNodeData) =>
    getImageGenericCrusher({
      modelName: data.modelName,
      useHighBin: data.useHighBin ?? false,
    }),
  ),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default GenericCrusherTemplate;
